import { SVGAttributes } from "react"
const MergeAccountIllustration = (props: SVGAttributes<any>) => (
   <svg viewBox="0 0 224 509" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g opacity="0.7">
         <g filter="url(#filter0_d_685_17)">
            <path
               d="M115.577 279.121C115.85 281.304 109.575 288.397 90.7515 307.084C76.8385 320.86 64.835 331.909 63.8802 331.773C62.9254 331.5 50.7856 320.042 36.8725 306.129C20.5042 289.897 11.638 279.94 11.638 278.166C11.638 276.666 13.0021 274.074 14.7753 272.301C16.4121 270.664 19.1402 269.3 20.9134 269.3C22.823 269.3 28.8247 274.211 38.6457 283.623C46.6935 291.398 53.65 297.945 54.332 297.945C54.8776 297.945 55.2868 283.623 55.2868 266.299C55.2868 242.702 55.8324 194.109 57.3329 187.562C58.5605 182.651 61.9706 173.512 65.1078 167.101C69.4727 158.235 73.292 153.052 81.2033 145.277C88.4327 138.048 94.7072 133.274 102.346 129.318C108.347 126.181 118.441 122.361 124.852 120.861C131.263 119.224 137.947 117.997 139.856 117.997C142.584 117.997 143.812 116.769 145.995 111.449C147.495 107.903 150.223 103.265 152.133 101.083C154.042 98.9002 158.68 95.6265 162.363 93.5805C167.819 90.8525 171.093 90.1704 178.731 90.1704C186.37 90.1704 189.643 90.8524 195.099 93.5805C198.919 95.6265 203.966 99.5822 206.421 102.447C208.876 105.311 211.877 110.767 212.968 114.586C214.469 119.088 215.014 123.998 214.605 128.909C214.196 133.001 212.559 138.866 211.059 141.867C209.558 144.868 206.284 149.233 203.693 151.688C201.238 154.007 196.463 157.28 193.053 158.781C189.098 160.554 184.051 161.645 178.731 161.645C173.002 161.645 168.501 160.691 163.727 158.372C160.044 156.735 154.724 152.916 152.133 149.915C149.405 147.05 146.404 142.549 145.313 140.094C143.812 136.684 142.448 135.592 139.856 135.729C137.947 135.729 132.763 136.684 128.262 137.775C123.761 139.003 116.122 141.867 111.212 144.322C105.756 147.05 98.9357 152.097 93.4796 157.553C87.4778 163.419 83.113 169.557 79.9757 175.968C77.3841 181.151 74.5196 190.153 73.5648 195.746C72.4736 201.748 71.7916 255.114 71.6552 270.937C71.6552 285.805 72.0644 298.218 72.7464 298.627C73.292 298.9 77.3841 295.49 82.0218 290.716C86.6595 286.078 93.4796 279.394 97.4352 275.848C101.255 272.165 105.347 269.3 106.438 269.3C107.529 269.3 109.984 270.801 111.894 272.71C113.804 274.62 115.44 277.484 115.577 279.121Z"
               fill="white"
            />
            <path
               d="M73.0192 140.503L68.6543 146.232C66.3354 149.506 64.0166 152.097 63.6074 152.097C63.1982 152.097 60.7429 149.642 53.9228 141.185L53.9228 77.0758L48.1939 74.2113C44.9202 72.5745 40.2826 69.4372 37.8273 66.982C35.2356 64.6632 31.962 60.2983 30.3252 57.2974C28.1427 53.2053 27.4607 49.2497 27.4607 41.6111C27.3243 33.6998 28.0063 30.1533 30.3252 25.9248C31.8256 22.924 35.7813 18.0135 39.0549 14.8762C42.3286 11.8754 47.5119 8.46529 50.5127 7.51048C53.5136 6.41926 59.6517 5.60084 64.153 5.60084C70.4275 5.73726 73.974 6.55568 79.7029 9.69294C83.795 11.8754 88.8419 15.831 90.8879 18.4227C93.0703 21.0144 95.7984 25.9248 96.8896 29.3349C97.9808 32.7449 98.9356 38.2011 98.9356 41.6111C98.9356 45.0212 97.9808 50.4773 96.8896 53.8874C95.7984 57.2974 93.0703 62.2079 91.0243 64.7995C88.8419 67.3912 83.9314 71.0741 73.0192 76.3938L73.0192 140.503Z"
               fill="white"
            />
         </g>
         <path
            d="M194.008 137.229C192.235 139.685 188.689 142.413 186.097 143.367C183.505 144.322 180.368 145.141 179.14 145.277C177.776 145.277 174.639 144.459 172.32 143.504C169.865 142.413 166.182 139.685 164.136 137.366C161.135 133.956 160.317 131.637 160.317 126.59C160.317 122.498 161.272 118.406 163.045 115.678C164.545 113.222 167.683 110.222 169.865 109.13C172.184 108.039 176.276 107.084 179.14 107.084C181.868 107.084 186.233 108.312 188.689 109.812C191.007 111.313 194.008 114.314 195.099 116.632C196.191 118.951 197.146 123.453 197.146 126.863C197.146 131.228 196.191 134.228 194.008 137.229Z"
            fill="#E6E6E6"
         />
         <path
            d="M79.021 49.5225C76.9749 52.7961 73.4285 56.6154 71.1096 58.1158C67.9724 60.1619 65.5171 60.7075 61.425 60.1619C58.4242 59.7527 54.6049 58.3886 52.9681 57.2974C51.1948 56.2062 48.6032 53.2053 46.9664 50.8865C45.0567 47.6128 44.3747 44.612 44.6475 39.9743C44.9203 34.9274 46.0115 32.745 49.8308 28.7893C52.8317 25.652 56.3781 23.4696 59.379 23.0604C61.9706 22.5148 66.4719 22.924 69.3364 23.7424C72.3372 24.5608 75.7473 27.016 77.6569 29.7441C79.4302 32.0629 81.3398 36.2914 81.8854 38.8831C82.5674 42.7023 81.8854 44.8848 79.021 49.5225Z"
            fill="#B5D5C6"
         />
         <g filter="url(#filter1_d_685_17)">
            <circle cx="67.0267" cy="438.101" r="60.462" fill="white" />
         </g>
         <circle cx="67.027" cy="438.101" r="41.3507" fill="#E6E6E6" />
         <circle cx="67.0269" cy="438.101" r="33.1192" fill="#B5D5C6" />
      </g>
      <defs>
         <filter
            id="filter0_d_685_17"
            x="2.63794"
            y="0.600845"
            width="221.099"
            height="344.173"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
         >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
               in="SourceAlpha"
               type="matrix"
               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
               result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="4.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_685_17" />
            <feBlend
               mode="normal"
               in="SourceGraphic"
               in2="effect1_dropShadow_685_17"
               result="shape"
            />
         </filter>
         <filter
            id="filter1_d_685_17"
            x="0.564697"
            y="375.639"
            width="132.924"
            height="132.924"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
         >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
               in="SourceAlpha"
               type="matrix"
               values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
               result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_685_17" />
            <feBlend
               mode="normal"
               in="SourceGraphic"
               in2="effect1_dropShadow_685_17"
               result="shape"
            />
         </filter>
      </defs>
   </svg>
)

export default MergeAccountIllustration
